import React, { useState, useEffect, useRef }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import MetricDetailGenericTypeColumnEditor from './objectInputs/metricDetailGenericTypeColumnEditor';
import MetricDetailOtherColumnOptionsEditor from './objectInputs/metricDetailOtherColumnOptionsEditor';

const groupByInitialObjectState = {
  type: "",
  id: ""
}

const orderByInitialObjectState = {
  type: "",
  id: "",
  direction: "",
  order: ""  
}

const transformationsInitialObjectState = {
  type: "",
  id: "",
  transformation: ""
}

const MetricDetailColumnsEditorPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    metricDetailColumnData,
    metricDetailColumnsMetricMetadata,
    popupState
  } = props;
  let label = metricDetailColumnData ? metricDetailColumnData.label : "";
  return (
    <GlassPopup
      className={"form_popup metric_detail_columns_editor_popup full_screen_popup"}
      title={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.title"}) + ": " + label}
      handleButton={handleButton}
      buttonText={(<FormattedMessage id={"reportTemplateAdmin.metricDetailColumnsEditor.saveButton"}/>)}
      handleAlternativeButton={handleShowPopup}
      alternativeButtonText={(<FormattedMessage id={"reportTemplateAdmin.metricDetailColumnsEditor.cancelButton"}/>)}
      {...props}
    >
      {(metricDetailColumnData && metricDetailColumnsMetricMetadata) ? (
        <div className="metric_detail_columns_editor_popup_inner">
          <div className="metric_detail_columns_editor_popup_inner_help">
            <label className="form_info"><FormattedMessage id={"reportTemplateAdmin.metricDetailColumnsEditor.help"}/></label>
          </div>
          <div className={"metric_detail_columns_editor_popup_inner_row" + (metricDetailColumnsMetricMetadata.virtualCalculation ? " metric_detail_columns_editor_popup_inner_row_virtual_calculation" : "")}>                 
            <MetricDetailGenericTypeColumnEditor 
              data-path="dimension_columns_descriptor"
              values={metricDetailColumnData.dimension_columns_descriptor}
              columnOptions={metricDetailColumnsMetricMetadata.dimensionOptions}
              columnType={Constants.selectKeys.reportMetricsDetail.columnTypes.DIMENSION}
              titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.dimension_columns_descriptor"})}
              onChange={handleOnChangeForm}
            />
            <MetricDetailGenericTypeColumnEditor 
              data-path="values_columns_descriptor"
              values={metricDetailColumnData.values_columns_descriptor}
              columnOptions={metricDetailColumnsMetricMetadata.valueOptions}
              columnType={Constants.selectKeys.reportMetricsDetail.columnTypes.VALUE}
              titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.values_columns_descriptor"})}
              onChange={handleOnChangeForm}
            />
            {(!metricDetailColumnsMetricMetadata.virtualCalculation) && (
              <MetricDetailGenericTypeColumnEditor 
                data-path="virtual_columns_descriptor"
                values={metricDetailColumnData.virtual_columns_descriptor}
                columnOptions={null}
                columnType={Constants.selectKeys.reportMetricsDetail.columnTypes.VIRTUAL}
                titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.virtual_columns_descriptor"})}
                onChange={handleOnChangeForm}
              />
            )}
          </div>
          <div className="metric_detail_columns_editor_popup_inner_row">
            <MetricDetailOtherColumnOptionsEditor
              initialObjectState={transformationsInitialObjectState}
              requiredFields={[]}
              typeColumnOptions={
                metricDetailColumnsMetricMetadata.virtualCalculation ?
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.columnTypesMetricCalculation","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptionsMetricCalculation") :
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.columnTypes","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptions")
              }
              dimensionColumnOptions={metricDetailColumnsMetricMetadata.dimensionOptions}
              valueColumnOptions={metricDetailColumnsMetricMetadata.valueOptions}
              virtualColumnOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricDetailColumnData.virtual_columns_descriptor ? metricDetailColumnData.virtual_columns_descriptor : [], "id", "id")}
              data-path="transformations_descriptor"
              titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.transformations_descriptor"})}
              values={metricDetailColumnData.transformations_descriptor}
              onChange={handleOnChangeForm}
            />
            <MetricDetailOtherColumnOptionsEditor
              initialObjectState={groupByInitialObjectState}
              requiredFields={[]}
              typeColumnOptions={
                metricDetailColumnsMetricMetadata.virtualCalculation ?
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.columnTypesMetricCalculation","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptionsMetricCalculation") :
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.columnTypes","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptions")
              }
              dimensionColumnOptions={metricDetailColumnsMetricMetadata.dimensionOptions}
              valueColumnOptions={metricDetailColumnsMetricMetadata.valueOptions}
              virtualColumnOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricDetailColumnData.virtual_columns_descriptor ? metricDetailColumnData.virtual_columns_descriptor : [], "id", "id")}
              data-path="group_by_descriptor"
              titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.group_by_descriptor"})}
              values={metricDetailColumnData.group_by_descriptor}
              onChange={handleOnChangeForm}
            />
            <MetricDetailOtherColumnOptionsEditor
              initialObjectState={orderByInitialObjectState}
              requiredFields={[]}
              typeColumnOptions={
                metricDetailColumnsMetricMetadata.virtualCalculation ?
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.columnTypesMetricCalculation","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptionsMetricCalculation") :
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.columnTypes","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptions")
              }
              dimensionColumnOptions={metricDetailColumnsMetricMetadata.dimensionOptions}
              valueColumnOptions={metricDetailColumnsMetricMetadata.valueOptions}
              virtualColumnOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricDetailColumnData.virtual_columns_descriptor ? metricDetailColumnData.virtual_columns_descriptor : [], "id", "id")}
              data-path="order_by_descriptor"
              titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.order_by_descriptor"})}
              values={metricDetailColumnData.order_by_descriptor}
              onChange={handleOnChangeForm}
            />
          </div>
        </div>
      ) : (metricDetailColumnData) ? (
        <div className="no_period_selected_wrapper">
          {intl.formatMessage({ id: "reportTemplateAdmin.metricDetailColumnsEditor.noMetricSelected" })}
        </div>
      ) : null}
    </GlassPopup>
  );
};

export default MetricDetailColumnsEditorPopup;



// WEBPACK FOOTER //
// ./source/client/components/reportTemplateAdmin/metricDetailColumnsEditorPopup.jsx